export var SERVERTIME_CHECK_FLAG = "server_time_check";
export var ACCEPTABLE_SERVER_TIME_VARIANCE = 5 * 60 * 1000; // ms
